import { useMediaQuery as useMediaQueryReactResponsive } from "react-responsive";

export const useDesktopMediaQuery = () =>
  useMediaQueryReactResponsive({ query: "(min-width: 1280px)" });
export const useTabletAndBelowMediaQuery = () =>
  useMediaQueryReactResponsive({ query: "(max-width: 1279px)" });

export default function useMediaQuery() {
  const isDesktop = useDesktopMediaQuery();
  const isMobile = useTabletAndBelowMediaQuery();

  return {
    isDesktop,
    isMobile,
  };
}
